import { render, staticRenderFns } from "./digital_config.vue?vue&type=template&id=536bee66&scoped=true"
import script from "./digital_config.vue?vue&type=script&lang=js"
export * from "./digital_config.vue?vue&type=script&lang=js"
import style0 from "./digital_config.vue?vue&type=style&index=0&id=536bee66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bee66",
  null
  
)

export default component.exports